const API_BASE = process.env.REACT_APP_API_BASE_URL || "/api";

const request = async (path, options = {}) => {
  if (typeof fetch === "undefined") {
    throw new Error("Fetch is not available.");
  }

  const response = await fetch(`${API_BASE}${path}`, {
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {})
    },
    ...options
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "API request failed.");
  }

  return data;
};

export const getRandomWord = async () => {
  const data = await request("/get-word.php");
  return data.word;
};

export const updateGuessResult = async ({
  wordId,
  activeHintId,
  previousHintIds,
  correct,
  contributorId
}) =>
  request("/update-guess.php", {
    method: "POST",
    body: JSON.stringify({
      wordId,
      activeHintId,
      previousHintIds,
      correct,
      contributorId
    })
  });

export const submitHint = async ({ wordId, text, contributorId }) => {
  const data = await request("/submit-hint.php", {
    method: "POST",
    body: JSON.stringify({ wordId, text, contributorId })
  });
  return data.hint;
};

export const getWordsByIds = async (wordIds) => {
  if (wordIds.length === 0) return [];

  const params = new URLSearchParams({ ids: wordIds.join(",") });
  const data = await request(`/get-words.php?${params.toString()}`);
  return data.words;
};

export const getContributions = async (contributorId) => {
  const params = new URLSearchParams({ contributorId });
  const data = await request(`/get-contributions.php?${params.toString()}`);
  return data.hints;
};
